<script setup lang="ts">
import type { WithPictureUrlPipedriveUser } from '@models/interfaces/withPictureUrlPipedriveUser';
import { computed } from 'vue';
import { type Color, getColorValue } from '@global-types/colors';
import IconStatusWhite from '@icons/ph_status_white.svg';
import Icon from './Icon.vue';

const { pipedriveUser, size = 24, isOnline = false } = defineProps<{
  pipedriveUser: WithPictureUrlPipedriveUser,
  size?: number,
  isOnline?: boolean
}>();

const initials = computed<string>(() => {
  const { firstname } = pipedriveUser;
  return firstname[0].toUpperCase();
  // @todo Standby for now, specs to come
  // const lastname = props.pipedriveUser.lastname;
  // return firstname[0].toUpperCase() + lastname[0].toUpperCase();
});

const colors: Color[] = [ 'green', 'blue', 'red', 'yellow', 'orange', 'black', 'purple' ];

const backgroundColor = computed<string>(() => {
  const letter = initials.value[0];
  if (!letter) {
    return 'black';
  }
  const normalized = letter.toUpperCase().charCodeAt(0);
  const index = normalized % colors.length;
  return getColorValue(colors[index]);
});
</script>

<template>
  <div class="user-picture">
    <div
      v-if="pipedriveUser.picture_url"
      class="user-picture__image picture-image"
    >
      <img
        class="picture-image__media"
        :style="{ width: `${size}px`, height: `${size}px` }"
        :src="pipedriveUser.picture_url"
        :alt="pipedriveUser.firstname"
      >
    </div>
    <div
      v-else
      class="user-picture__initials"
      :style="{ width: `${size}px`, height: `${size}px`, backgroundColor }"
    >
      {{ initials }}
    </div>
    <Icon
      v-if="isOnline"
      :svg="IconStatusWhite"
      class="user-picture__online-status"
    />
  </div>
</template>
